var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 833,
    height: 569,
    viewBox: "0 0 833 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.739 91.5018C218.185 134.219 198.694 177.942 161.745 198.248L222.096 423.482C241.347 495.326 239.135 537.541 229.187 540.207C219.482 542.807 196.151 507.176 176.966 435.575L116.614 210.34C74.3979 210.987 35.9638 183.045 24.5178 140.328C11.0558 90.0869 40.5206 37.9686 90.9894 24.4455C141.701 10.8575 193.277 41.2609 206.739 91.5018ZM51.1558 104.835C55.7082 121.825 74.1686 132.487 90.9107 128.001C107.895 123.45 118.066 105.116 113.514 88.1267C109.027 71.3796 91.1165 60.8306 74.132 65.3816C57.3899 69.8676 46.6685 88.0884 51.1558 104.835Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M807.792 144.741C796.346 187.458 757.605 215.577 715.453 214.688L655.102 439.923C635.851 511.767 612.829 547.22 602.88 544.554C593.175 541.954 590.786 499.431 609.971 427.83L670.323 202.596C633.439 182.047 614.125 138.632 625.571 95.9147C639.033 45.6737 690.609 15.2703 741.078 28.7934C791.789 42.3814 821.254 94.4998 807.792 144.741ZM666.386 78.4964C661.834 95.486 672.49 113.95 689.232 118.436C706.217 122.987 724.192 112.195 728.744 95.2052C733.232 78.4581 722.996 60.3674 706.011 55.8164C689.269 51.3303 670.874 61.7493 666.386 78.4964Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.23 216.23L259.785 231.471C362.153 267.294 473.709 266.928 575.84 230.434L615.593 216.23",
    stroke: "#ffffff",
    strokeWidth: 50,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.d64e74c2a04ba6b6ce8aa499a1b781be.svg";
export { ForwardRef as ReactComponent };